import React from 'react';
import AiManagementCheckbox from 'components/atoms/ai_management_checkbox';
import { Toolbar } from './styles';

const SOON_TITLE = 'Ação ainda não disponível';

interface AiManagementItemsToolbarProps {
  id: string;
  shown: number;
  total: number;
  showActions: boolean;
  allSelected: boolean;
  selectedCount: number;
  allSelectedInterested: boolean;
  generating: boolean;
  showAccessFile: boolean;
  onToggleAll: () => void;
  onToggleInterest: () => void;
  onGenerate: () => void;
  onOpenBidderFiles: () => void;
}

const AiManagementItemsToolbar: React.FC<AiManagementItemsToolbarProps> = ({
  id,
  shown,
  total,
  showActions,
  allSelected,
  selectedCount,
  allSelectedInterested,
  generating,
  showAccessFile,
  onToggleAll,
  onToggleInterest,
  onGenerate,
  onOpenBidderFiles,
}) => (
  <Toolbar>
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="mb-0 font-weight-bold text-dark">Itens</h6>
      {showActions ? (
        <span className="text-muted">
          {shown} {shown === 1 ? 'item' : 'itens'} de {total.toLocaleString('pt-BR')}
        </span>
      ) : null}
    </div>

    {showActions ? (
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
        <AiManagementCheckbox
          id={`${id}-select-all`}
          checked={allSelected}
          className="mr-3 my-1"
          onChange={onToggleAll}
        >
          Selecionar todos itens da página
        </AiManagementCheckbox>

        <div className="d-flex flex-wrap">
          <button
            type="button"
            className="btn btn-secondary ml-1 my-1"
            disabled={!selectedCount}
            onClick={onToggleInterest}
          >
            {allSelectedInterested ? 'Remover dos interesses' : 'Marcar como interesse'}
            {selectedCount ? ` (${selectedCount})` : ''}
          </button>
          <button type="button" className="btn btn-secondary ml-1 my-1" disabled title={SOON_TITLE}>
            Compartilhar
          </button>
          <button
            type="button"
            className="btn btn-secondary dropdown-toggle ml-1 my-1"
            disabled
            title={SOON_TITLE}
          >
            Exportar
          </button>
          {showAccessFile ? (
            <button
              type="button"
              className="btn btn-link d-inline-flex align-items-center ml-2 my-1"
              onClick={onOpenBidderFiles}
            >
              <i className="material-icons mr-1">check</i>
              Acessar arquivo do licitante
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-primary d-inline-flex align-items-center ml-1 my-1"
              disabled={generating || !selectedCount}
              title={selectedCount ? undefined : 'Selecione ao menos um item'}
              onClick={onGenerate}
            >
              {generating ? (
                <span className="spinner-border spinner-border-sm mr-2" aria-hidden />
              ) : (
                <i className="material-icons mr-1">file_copy</i>
              )}
              {generating ? 'Gerando arquivo...' : 'Gerar arquivo do licitante'}
            </button>
          )}
        </div>
      </div>
    ) : null}
  </Toolbar>
);

export default AiManagementItemsToolbar;
